// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stock-dashboard {
  max-width: 100%;
  height: calc(100vh - 120px);
  margin: 0 auto;
  animation: slideIn 0.3s ease;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.dashboard-header {
  flex-shrink: 0;
}

.dashboard-header h2 {
  font-size: 1.8rem;
  margin-bottom: 1rem;
  text-align: center;
  background: linear-gradient(135deg, #00ff88 0%, #00ccff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.stats-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.stat-card {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 1rem;
  text-align: center;
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 40px rgba(0, 255, 136, 0.1);
}

.stat-label {
  font-size: 0.9rem;
  color: #888;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, #00ff88 0%, #00ccff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.drinks-dashboard {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 2rem;
  margin-bottom: 1rem;
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 0.5rem;
  scroll-behavior: smooth;
}

.drink-dashboard-card {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 1.5rem;
  transition: all 0.3s ease;
}

.drink-dashboard-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 40px rgba(0, 255, 136, 0.1);
}

.drink-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.drink-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.drink-icon {
  font-size: 1.5rem;
}

.drink-name {
  font-size: 1rem;
  font-weight: 600;
}

.drink-stats {
  text-align: right;
}

.current-price {
  font-size: 1.2rem;
  font-weight: 700;
  color: #00ff88;
}

.price-change {
  font-size: 0.9rem;
  font-weight: 600;
  margin-top: 0.25rem;
}

.price-change.positive {
  color: #ff4444;
}

.price-change.negative {
  color: #00ff88;
}

.chart-container {
  height: 150px;
  margin: 1rem 0;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  padding: 0.5rem;
}

.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #666;
  font-size: 0.9rem;
}

.drink-footer {
  display: flex;
  justify-content: space-between;
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-stat {
  display: flex;
  flex-direction: column;
}

.footer-stat .label {
  font-size: 0.8rem;
  color: #888;
  margin-bottom: 0.25rem;
}

.footer-stat .value {
  font-size: 1.1rem;
  font-weight: 600;
}

.recent-sales {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 1.5rem;
}

.recent-sales h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #00ff88;
}

.sales-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.sale-item {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 1rem;
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  align-items: center;
  transition: all 0.3s ease;
}

.sale-item:hover {
  background: rgba(0, 255, 136, 0.05);
}

.sale-drink {
  font-weight: 600;
}

.sale-quantity {
  text-align: center;
  color: #888;
}

.sale-price {
  text-align: right;
  color: #00ff88;
  font-weight: 600;
}

.sale-time {
  text-align: right;
  color: #666;
  font-size: 0.9rem;
}

.no-sales {
  text-align: center;
  padding: 2rem;
  color: #666;
}

/* Recharts customization */
.recharts-cartesian-grid-horizontal line,
.recharts-cartesian-grid-vertical line {
  stroke: #333;
}

.recharts-text {
  fill: #888;
}

.recharts-tooltip-wrapper {
  outline: none;
}

.recharts-default-tooltip {
  background-color: #1a1a1a !important;
  border: 1px solid #333 !important;
  border-radius: 8px;
}

.recharts-tooltip-label {
  color: #888;
}




/* Hide scrollbar but keep functionality */
.drinks-dashboard::-webkit-scrollbar {
  width: 6px;
}

.drinks-dashboard::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.02);
}

.drinks-dashboard::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
}

.drinks-dashboard::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/components/StockDashboard.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,2BAA2B;EAC3B,cAAc;EACd,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,iGAAiG;EACjG,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;EACnB,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,iGAAiG;EACjG,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iGAAiG;EACjG,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA,2BAA2B;AAC3B;;EAEE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;;;;AAKA,0CAA0C;AAC1C;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".stock-dashboard {\n  max-width: 100%;\n  height: calc(100vh - 120px);\n  margin: 0 auto;\n  animation: slideIn 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.dashboard-header {\n  flex-shrink: 0;\n}\n\n.dashboard-header h2 {\n  font-size: 1.8rem;\n  margin-bottom: 1rem;\n  text-align: center;\n  background: linear-gradient(135deg, #00ff88 0%, #00ccff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.stats-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.stat-card {\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 1rem;\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 40px rgba(0, 255, 136, 0.1);\n}\n\n.stat-label {\n  font-size: 0.9rem;\n  color: #888;\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.stat-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #00ff88 0%, #00ccff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.drinks-dashboard {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 2rem;\n  margin-bottom: 1rem;\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-right: 0.5rem;\n  scroll-behavior: smooth;\n}\n\n.drink-dashboard-card {\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding: 1.5rem;\n  transition: all 0.3s ease;\n}\n\n.drink-dashboard-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 40px rgba(0, 255, 136, 0.1);\n}\n\n.drink-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.drink-info {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.drink-icon {\n  font-size: 1.5rem;\n}\n\n.drink-name {\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.drink-stats {\n  text-align: right;\n}\n\n.current-price {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #00ff88;\n}\n\n.price-change {\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin-top: 0.25rem;\n}\n\n.price-change.positive {\n  color: #ff4444;\n}\n\n.price-change.negative {\n  color: #00ff88;\n}\n\n.chart-container {\n  height: 150px;\n  margin: 1rem 0;\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 8px;\n  padding: 0.5rem;\n}\n\n.no-data {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.drink-footer {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 1rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.footer-stat {\n  display: flex;\n  flex-direction: column;\n}\n\n.footer-stat .label {\n  font-size: 0.8rem;\n  color: #888;\n  margin-bottom: 0.25rem;\n}\n\n.footer-stat .value {\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.recent-sales {\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding: 1.5rem;\n}\n\n.recent-sales h3 {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n  color: #00ff88;\n}\n\n.sales-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.sale-item {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr 1fr;\n  gap: 1rem;\n  padding: 0.75rem;\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 8px;\n  align-items: center;\n  transition: all 0.3s ease;\n}\n\n.sale-item:hover {\n  background: rgba(0, 255, 136, 0.05);\n}\n\n.sale-drink {\n  font-weight: 600;\n}\n\n.sale-quantity {\n  text-align: center;\n  color: #888;\n}\n\n.sale-price {\n  text-align: right;\n  color: #00ff88;\n  font-weight: 600;\n}\n\n.sale-time {\n  text-align: right;\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.no-sales {\n  text-align: center;\n  padding: 2rem;\n  color: #666;\n}\n\n/* Recharts customization */\n.recharts-cartesian-grid-horizontal line,\n.recharts-cartesian-grid-vertical line {\n  stroke: #333;\n}\n\n.recharts-text {\n  fill: #888;\n}\n\n.recharts-tooltip-wrapper {\n  outline: none;\n}\n\n.recharts-default-tooltip {\n  background-color: #1a1a1a !important;\n  border: 1px solid #333 !important;\n  border-radius: 8px;\n}\n\n.recharts-tooltip-label {\n  color: #888;\n}\n\n\n\n\n/* Hide scrollbar but keep functionality */\n.drinks-dashboard::-webkit-scrollbar {\n  width: 6px;\n}\n\n.drinks-dashboard::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.drinks-dashboard::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 3px;\n}\n\n.drinks-dashboard::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.2);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
